<!-- 组件说明 -->
<template>
<div>
  <van-nav-bar
      :title="$t('Pay.success')"
      @click-left="onClickLeft"
      class="nav_title"
      />
      <div>
      <div class="order_top">
        <h2>{{$t('Pay.waitFor')}}</h2>
        <p>{{time}}</p>
      </div>
      <div class="padding-16" style="text-align:center">
        <span @click="onClickLeft">{{ count }}{{$t('Pay.to')}}</span>
      </div>
      <div class="padding-16">
        <p>{{res.customerName}}</p>
        <span>{{res.address}}</span>
      </div>
      
      <van-card
        v-for="(item,index) in orderList" :key="index"
        :num="item.prodCount"
        :price="item.price"
        :title="item.prodName"
        :thumb="item.pic"
        :currency="$t('Pay.money')"
      >
      </van-card>
      <van-divider dashed />
      <div class="padding-16">
        <div class="order_list" >
          <!-- <p>实付金额: </p> -->
          <p>{{$t('Pay.realMoney')}}: </p>
          <p>{{$t('Pay.money')}}{{total}}</p>
        </div>
        <!-- <div class="order_list" >
          <div><p>{{$t('Pay.orderNumber')}}: </p></div>
          <div><p>{{orderNumber}}</p></div>
        </div> -->
      </div>
  </div>
</div>
 
</template>

<script>
//import x from '' 
// import { NavBar } from 'vant';
import goods from "@/api/goods";
import { mapMutations, mapState } from 'vuex';
import googFb from '../../google/google'
export default {
  components: {},
  data() {
    return {
       titleName:'下单成功',//标题名字
       count: '' ,// 倒计时
       List:[],
       pic: [],
       properties: [],
       countList:[],
       res:{
         orderItems:[
           
         ]
       },
       orderList:[],
       orderNumber:'',
       total:'',
       time:'',
    };
  },
  computed: {
      
  },
  methods: {
    onClickLeft(){
      this.$router.replace('/');
    },
    getOrderList(){
      let param = sessionStorage.getItem('token_order')
      console.log('param',param)
      let paramList = []
      if(param.indexOf(',')!=-1){
        paramList = param.split(',')
      }else{
        paramList.push(param)
      }
      let resList = []
     paramList.forEach((item,index)=>{
       
       goods.orderTem(item).then(res=>{
         this.time = res.createTime
         resList.push(res.total)
         this.res = res
         res.orderItems.forEach((item,index)=>{
           this.orderList.push(item)
         })
        // this.orderList.push(res.orderItems)
        // console.log('this.orderList',this.orderList)
        // console.log('resList',resList.reduce((total,item)=>total + item))
        this.total = resList.reduce((total,item)=>total + item)
        this.orderNumber = sessionStorage.getItem('token_order')
      })
     })
    },
    goChoicePeople() {
      const TIME_COUNT = 60
      if (!this.timer) {
        this.count = TIME_COUNT
        this.show = false
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count--
          } else {
            this.show = true
            clearInterval(this.timer)
            this.timer = null
            // 跳转到选人加分界面
            this.$router.push('/')
          }
        }, 1000)
      }
    }
  },
  created() {
    this.goChoicePeople()
    this.getOrderList()
    // alert(sessionStorage.getItem('token_order'))
    //生命周期 - 创建完成
      // this.List = this.$store.state.designer.List
      // this.properties = this.$store.state.designer.imgList
      // this.countList = this.$store.state.designer.numList
      // this.pic = this.$store.state.designer.pic
      // this.titleName = this.$store.state.designer.titleName;

      // console.log('=====fbq-OrderSuceess=====',fbq)
      // let fbValue = []
      // let num = 0
      // fbValue = sessionStorage.getItem('numberValue')
      // if(fbValue.indexOf(',')!=-1){
      //   fbValue = fbValue.split(',')
      //     fbValue.forEach((item,index)=>{
      //       num = num+Number(item)
      //     })
      // }else{
      //   num = Number(fbValue)
      // }
      // fbq('track', 'Purchase', {value: num, currency: 'USD'});
  },
  mounted(){
    let goRop = sessionStorage.getItem('googleRop')
    let goEvent = sessionStorage.getItem('googleEvent')
    goEvent = JSON.parse(goEvent)
    if(goEvent){
      googFb.addTocar(goRop,goEvent)
    }
  },
  destroyed() {
    clearInterval(this.timer)
    sessionStorage.removeItem('token_order')
    sessionStorage.removeItem('numberValue')
    //   this.$store.state.designer.List =[]
    //   this.$store.state.designer.imgList =[]
    //   this.$store.state.designer.numList =[]
    //   this.$store.state.designer.pic =[]
    //生命周期 - 销毁完成
  },
};
</script>

<style lang='scss' scoped>
.success {
  padding: 2rem 0.5rem 0 0.5rem;
  display: flex;
  align-items: center;
  flex-direction: column;
  box-sizing: border-box;
  .icon {
    font-size: 2rem;
    color: #38f;
  }
}
.order_top{
  background:rgb(252, 66, 112);padding:16px;min-height:40px;color:white
}
.padding-16{
  padding: 16px;
}
.order_list{
  display:flex;justify-content: space-between;
  padding: 5px 0;
}
.order_list:nth-child(1) p:nth-child(2){
  color: #ee0a24
}
.order_list:nth-child(2) p:nth-child(2){
  color: #ccc
}
</style>


// WEBPACK FOOTER //
// src/pages/Detailsuccess/Detailsuccess.vue